export default __webpack_public_path__ + "static/media/phone-android.227669fe.svg";